<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-6">
        <table>
          <td style="vertical-align: middle;"><img src="assets/img/global/despesa-prevista.png" alt="" title=""
              width="42" height="42">
          </td>
          <td>
            <p
              [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
              CRONOGRAMA DESEMBOLSO</p>
            <p
              [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
              EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}</p>
          </td>
        </table>
      </div>
      <div class="col-6">
        <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <span style="font-size: 13px;"><img src="assets/img/global/bullet_red.png" alt="soma" height="16" width="16" /> Confere</span>
        <span class="ml-3" style="font-size: 13px;"><img src="assets/img/global/bullet_green.png" alt="soma" height="16" width="16" /> Divergente</span>
      </div>
    </div>
    <div class="row  mt-1">
      <div class="col-md">
        <table class="table table-eddy" style="font-size:11px">
          <thead>
            <tr>
              <th scope="col" class="text-left">FH.</th>
              <th scope="col" class="text-left">Código</th>
              <th scope="col" class="text-left">Nome</th>
              <th scope="col" class="text-right">Janeiro</th>
              <th scope="col" class="text-right">Fevereiro</th>
              <th scope="col" class="text-right">Março</th>
              <th scope="col" class="text-right">Abril</th>
              <th scope="col" class="text-right">Maio</th>
              <th scope="col" class="text-right">Junho</th>
              <th scope="col" class="text-right">Julho</th>
              <th scope="col" class="text-right">Agosto</th>
              <th scope="col" class="text-right">Setembro</th>
              <th scope="col" class="text-right">Outubro</th>
              <th scope="col" class="text-right">Novembro</th>
              <th scope="col" class="text-right">Dezembro</th>
              <th scope="col" class="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaPlanilha">
              <th class="text-left" style="width: 4%;">
                <span *ngIf="arrecadado(item) !== (+item.fh_valor_orcado).toFixed(2)" [escape]="false"
                  pTooltip="{{escapePrevistoArrecadado(item)}}">
                  <img src="assets/img/global/bullet_red.png" alt="soma" height="16" width="16" />
                </span>
                <span *ngIf="arrecadado(item) === (+item.fh_valor_orcado).toFixed(2)" [escape]="false"
                  pTooltip="{{escapePrevistoArrecadado(item)}}">
                  <img src="assets/img/global/bullet_green.png" alt="soma" height="16" width="16" />
                </span>
                {{item.fh_numero}}
              </th>
              <th class="text-left">{{item.r_codigo}}</th>
              <td class="text-left">
                {{item.r_nome}}
              </td>
              <td class="text-right">{{item.previsto_jan | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_fev | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_mar | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_abr | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_mai | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_jun | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_jul | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_ago | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_set | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_out | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_nov | number:'1.2-2'}}</td>
              <td class="text-right">{{item.previsto_dez | number:'1.2-2'}}</td>
              <td class="text-right">
                {{+item.previsto_jan + +item.previsto_fev + +item.previsto_mar + +item.previsto_abr + +item.previsto_mai
                + +item.previsto_jun + +item.previsto_jul + +item.previsto_ago + +item.previsto_set + +item.previsto_out
                + +item.previsto_nov + +item.previsto_dez | number:'1.2-2'}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="listaPlanilha && listaPlanilha.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>